var eventResetSelection = new CustomEvent('reset_selection', {});
//MD5 hash for translations -  c484cf78a7f294fa6e86576c01cb69ac

window.dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}


function detectedBrowser() {
    const userAgent = navigator.userAgent;

    if (/Chrome/.test(userAgent) && !/Edge/.test(userAgent) && !/OPR/.test(userAgent)) {
        return 'chrome';
    } else if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
        return 'safari';
    } else {
        return 'other';
    }
};


jQuery(document).ready(function ($) {
    var originalProductPrice;
    var windowUrl;


    if ($('.type-product').hasClass('product-type-variable')) {
        $('.single_add_to_cart_button.disabled').on('click', function (e) {
            if ($(e.target).hasClass('disabled')) {
                document.getElementsByClassName('ub-errors')[0].scrollIntoView(false);
            }

        })
    }

    let $bb_product = $('.product_has_buy_box')
    if ($bb_product.length) {

        // loadSecondProductVariations($bb_product);
    }


    // function loadSecondProductVariations(product) {
    //     let bbSwatchOptionClass = 'bb-swatch-option';
    //     let $wrapper = $(product).find('.buy-box-wrapper');
    //     if ($wrapper.length && $wrapper.hasClass('bb-product-variable')) {
    //         if (!$wrapper.data('requestRunning')) {

    //             $wrapper.data('requestRunning', true);
    //             const nonce = $('#buy_box_nonce').val();
    //             let second_product_id = $wrapper.data('product');
    //             let second_product_id_2 = $wrapper.data('product_2');
    //             $.ajax({
    //                 url: '/wp-json/uppababy/v1/second-product/' + second_product_id + '?p2=' + second_product_id_2,
    //                 type: 'GET',
    //                 headers: {
    //                     'X-WP-Nonce': window.ubWCData.ub_rest_nonce
    //                 }
    //             }).then((r) => {

    //                 if (r.primary.length) {

    //                     const primary = JSON.stringify(r.primary)
    //                     const fallback = JSON.stringify(r.fallback)
    //                     $(product).find('.buy-box-wrapper').attr('data-variations', primary)
    //                     $(product).find('.buy-box-wrapper').attr('data-variations_2', fallback)
    //                     if ($(product).find(`.${bbSwatchOptionClass}.current`).length) {
    //                         setTimeout(function () {
    //                             $(`.product_has_buy_box .${bbSwatchOptionClass}.focus-ring.current`).trigger('click')
    //                         }, 200)
    //                     }
    //                     $wrapper.data('requestRunning', false);

    //                 }
    //             })
    //         }
    //     }
    // }



    function selectSwatch($this, isBBProduct = false) {



        const title = $this.data('label');
        const desc = $this.data('desc');
        const coming_soon = $this.data('coming-soon')



            const variableProductPrice = $this.data('price') ?? '';

            if (variableProductPrice.length) {

                $this.closest('.product').find('.price ').html(variableProductPrice);
                $this.closest('.wc-block-grid__product').find('.price ').html(variableProductPrice);
                $this.closest('.product').find('#mobile_summary p.price ').html(variableProductPrice);
            }


        $this.parents('.variations_form,.bundled_product ').find('.variation__details-title').removeClass('empty');
        $this.parents('.variations_form,.bundled_product').find('.variation__details-title p').html(title);
        $this.parents('.variations_form,.bundled_product').find('.variation__details-desc').html(desc).removeClass('empty');

        $this.parents('.variations_form,.bundled_product').find('.swatch-option').removeClass('current').attr("aria-pressed", false);
        $this.addClass('current').attr("aria-pressed", true);




    }

    if ($('aside.shop__filters')) {
        $('aside.shop__filters form, .shop__filter-crumbs').addClass('hidden-mobile')
    }

    function selectVariationOptions($this, country, style) {

        setTimeout(function () {
            if ($($this).closest('.variations_form').find('select[data-attribute_name="attribute_pa_styles"] [value="' + style + '"]')) {

                if ($($this).closest('.variations_form').find('select[data-attribute_name="attribute_pa_styles"]').val() !== style) {
                    $($this).closest('.variations_form').find('select[data-attribute_name="attribute_pa_styles"]').val(style).trigger('change');
                }
            }
        }, 300)
    }

    function selectVariation($this, country, style) {
        $this.parents('.variations_form').find('select[data-attribute_name="attribute_pa_countries"]').val($this.data('country')).trigger('change');
        setTimeout(function () {
            $this.parents('.variations_form').find('select[data-attribute_name="attribute_pa_styles"]').val($this.data('style')).trigger('change');

        }, 300)

        // check for other bundle items:

        if ($this.parents('.variations_form').hasClass('bundled_item_cart_content')) {

            const matches = $('.swatch-option[data-style="' + $this.data('style') + '"]')
            if (matches.length > 1) {

                const index = $(matches).index($this);

                // Don't attempt to propagate styles if swatch on secondary product is clicked
                // to avoid infinite loop
                if (index !== 0) {
                    return;
                }
                setTimeout(function () {
                    for (let i = 0; i < matches.length; i++) {
                        if (i !== index) {
                            selectSwatch($(matches[i]))
                            selectVariationOptions(matches[i], country, style)
                        }
                    }
                }, 100)


            }
        }
    }

    function setDefaultSwatches() {

        let variantGroupElement = $('.variations__swatches:eq(0)');

        let style = variantGroupElement.find('.swatch-option.current').data('style')

        if (!style) {
            style = variantGroupElement.find('.swatch-option:eq(0)').data('style')
        }

        $('.variations_form').each(function (ix) {

            if (!style || !style.length) {
                style = $(this).find('[id^="pa_styles"]').val()
            }
            let country = $(this).find('[id^="pa_countries"]').val()

            if (style.length && country.length) {
                const self = this
                setTimeout(function () {
                    $(self).find('.swatch-option[data-style="' + style + '"][data-country="' + country + '"]').trigger('click')
                    $(self).find('.mobile-swatch-option[data-style="' + style + '"][data-country="' + country + '"]').trigger('click')
                }, 300)

            }
        })

        $('.wc-block-grid__product').each(function (ix) {
            $(this).find('.swatch-option.current').trigger('click')
        })
    }

    function initProduct() {
        if ($('form.variations_form').length) {
            $form = $('form.variations_form');
        } else if ($('form.simple_form').length) {
            $form = $('form.simple_form');
        }
        variableProductPrice = variableTitle = variableDesc = '';
        originalProductPrice = $('p.price').html();

        windowUrl = typeof variablePermalink !== 'undefined' ? variablePermalink : $('meta[property="og:url"]').attr('content');
        setTimeout(function () {
            setDefaultSwatches()
        }, 300)


    }

    initProduct();
    
    // Initialize upsells product variation selection #UB-1356
    $(".up-sells li.product-type-variable .variations__group:eq(0) .swatch-option").removeClass('current').first().addClass('current').trigger('click');

    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function updateBuyBoxProductVariation(primaryProductStyle) {

        const $wrapper = $(this).closest('.product').find('.buy-box-wrapper');
        let data = $wrapper.data('variations');
        let data2 = $wrapper.data('variations_2');

        if (!data) return;

        if (typeof data === 'string') {
            data = JSON.parse($('<div/>').html(data).text());
            if (data2 && data2.length) {
                data2 = JSON.parse($('<div/>').html(data2).text());
            }
        }

        let selected = data.find(p => p.style === primaryProductStyle);
        if (!selected && data2 && data2.length) {
            selected = data2.find(p => p.style === primaryProductStyle);
        }

        if (selected) {
            $wrapper.find('.buy-box-product-price').show();
            $('.buy-box-wrapper .bb-price').html(selected.price);
            $wrapper.find('.sec-desc').html(selected.desc);
            if (selected.is_in_stock && !selected.coming_soon) {
                $wrapper.removeClass('not-available').addClass('available');
                $('#buy_box_product').attr('data-bbvariation', selected.variation_id).val(selected.product_id);
            } else {
                $('#buy_box_product').removeAttr('data-bbvariation').val(0);
                $wrapper.removeClass('available').addClass('not-available');
            }
        } else {
            $('#buy_box_product').prop('checked', false);
            $wrapper.removeClass('available').addClass('not-available');
            $('#buy_box_product').removeAttr('data-bbvariation').val(0);
        }

        $wrapper.removeClass('loading');
        $('#buy_box_product').prop('checked', false);
    }




    function ub_update_product($this, pushState = true, pushMobile = true) {
        let $_product = $this.closest('.product')



        if ($this == null) {

            $('#pa_styles  option:selected').prop('selected', false);
            $('#pa_styles').val([]).change().trigger('change');
            $('.summary p.price ').html(originalProductPrice);
            $('.variation__details-title').addClass('empty');
            $('.variation__details-title p').html('');
            $('.variation__details-desc').html('<p></p>').addClass('empty');
            $('.swatch-option').removeClass('current');
            $('.variation__details .ub-errors,.wc-block-grid__product .ub-errors').remove();
            $('.ub-add-to-cart').html('Select a fashion');
            $('form.variations_form').trigger('reload_product_variations');

            let data = { 'fashionchange': true, 'id': $this.data('id') };
            let url = windowUrl + $this.data('style') + '/';

            if (pushState && url.indexOf('undefined') === -1 && $('div.type-product').attr('class').split(/\s+/).filter(function (w) {
                return w.indexOf('product-type') !== -1
            })[0] !== 'product-type-bundle') {
                // history.replaceState(data, '', url);
            } else {

                selectVariation($this, $this.data('country'), $this.data('style'))
            }
        } else {

            let country = $this.data('country');
            let style = $this.data('style');
            if (pushMobile && !$this.parents('.overlay-quickview,.products,.wc-block-grid__products ').length) {

                setTimeout(function () {
                    let mobileSwatch = $('.atc-mob-swatch-list .mobile-swatch-option[data-style="' + style + '"]').first();
                    if (mobileSwatch && mobileSwatch.length) {

                        updateMobileSwatch(mobileSwatch)
                    }

                }, 300)

            }
            //clear options
            $_product.find('#pa_countries  option[value=""]').prop('selected', true);
            $_product.find('#pa_countries').val('').change();
            $_product.find('#pa_styles  option[value=""]').prop('selected', true);
            $_product.find('#pa_styles').val('').change();
            //set options
            $_product.find('#pa_countries  option[value=' + country + ']').prop('selected', true);
            $_product.find('#pa_countries').val(country).change();
            $_product.find('#pa_styles  option[value=' + $this.data('style') + ']').prop('selected', true);
            $_product.find('#pa_styles').val($this.data('style')).change();

            $_product.find('.summary .swatch-option').removeClass('current');

            $_product.find('.badges__badge-variation').removeClass('visible');
            $_product.find('.badges__badge-variation.' + $this.data('style')).addClass('visible');
            $_product.find('.certs__cert-variation').removeClass('visible');
            $_product.find('.certs__cert-variation.' + $this.data('style')).addClass('visible');

            selectSwatch($this);

            $_product.find('.variation__details .ub-errors, .ub-errors').remove();
            if ($this.data('coming-soon') === 1) {
                $_product.find('button.ub-add-to-cart').addClass('coming-soon-ajax').removeClass('single_add_to_cart_button ')
            } else {
                $_product.find('button.ub-add-to-cart').removeClass('coming-soon-ajax').addClass('single_add_to_cart_button')
            }


            if ($this.data('add-to-cart-label') != '') {

                const atc_label = $this.data('add-to-cart-label');

                $_product.find('.ub-add-to-cart').html(atc_label);

                $_product.find('.ub-add-to-cart').html(atc_label);
                if (window.location.search.indexOf('update-product') !== -1) {

                    const cart_key = getParameterByName('update-product');
                    $_product.find('.ub-add-to-cart').attr('data-update-product', cart_key);
                }



                //BANDAID FOR LUCY UK COMING SOON - TO BE FIXED 2023-04-04 MDP
                if ($this.find('add-to-cart-label') == 'Join Waitlist') {

                    $_product.find('a[href="/retail-locator"]').addClass('hidden');

                } else {
                    $_product.find('a[href="/retail-locator"]').html(wp.i18n.__('Where to buy?', 'uppababy')).removeClass('hidden');
                }
            }

            
            if ( $_product.find('button.ub-notify').length) {

                if (!$this.data('stock') && !$this.data('coming-soon')) {

                    $_product.find('button.ub-notify').removeClass('hidden').show()
                    if ($_product.find('button.ub-notify').data('suppress-oos')) {
                        $_product.find('.ub-add-to-cart').hide()
                    }
                } else {
                    $_product.find('button.ub-notify').hide()
                    if ($_product.find('button.ub-notify').data('suppress-oos')) {
                        $_product.find('.ub-add-to-cart').show()
                    }
                }
            }else{
                if(!$this.data('stock')){
                    $_product.find('.ub-add-to-cart,.bundle_add_to_cart_button ').attr('aria-disabled', true).attr('tabindex', "-1" )

                }else{
                    $_product.find('.ub-add-to-cart,.bundle_add_to_cart_button ').removeAttr('aria-disabled').removeAttr('disabled').removeAttr('tabindex')
                }
            }
            if ( $_product.find('button.ub-coming-soon').length) {
                if ($this.data('coming-soon')) {

                    $_product.find('.ub-add-to-cart').hide()
                    $_product.find('button.ub-coming-soon').removeClass('hidden').show()
                } else {

                    $_product.find('.ub-add-to-cart').show()
                    $_product.find('button.ub-coming-soon').addClass('hidden')

                }
            }

            //Exclsusive swatches
            if ($this.data('is_exclusive_swatch') == 1) {
                $_product.addClass('has_exclusive_swatch');
                $_product.find('a.exclusive_swatches_btn').removeClass('hidden');
                $_product.find('a.exclusive_swatches_btn').attr('href', $this.data('ex_swatches_url')).html($this.data('ex_swatches_button_text'));

            } else {
                $_product.removeClass('has_exclusive_swatch');
                $_product.find('a.exclusive_swatches_btn').addClass('hidden');
            }


            let $product = $_product;
            if ( $_product ) {
                $_product.find('.fine-print').remove();
                $_product.find('.fine-print-btns').remove();

                if ( $product.data('fine-print-link') != '' || $this.data('fine-print-link') != '') {
                    $_product.find('p.price').append($('<div class="fine-print-btns">'));
                    if ($product.data('fine-print-link') && $product.data('fine-print-link') != '') {
                        let isLastChance = ( $product.data('last-chance') == undefined || !$product.data('last-chance') ) ? "" : 'last-chance';
                        if( isLastChance != '' ){
                            $("#mobile_summary .fine-print").addClass(isLastChance);
                        }
                        let $pbtn = $('<button type="button" class="fint-print ' + isLastChance + '">' + $product.data('fine-print-link') + '</button>');
                        $_product.find('.fine-print-btns').append($pbtn);
                        let polContent = '<div class="fine-print__content" role="alertdialog" aria-label="' + $product.data('fine-print-link') + '" aria-modal="true">' + $product.data('fine-print-text') + '</div>';
                        $_product.find('.fine-print-btns button').on('click', function (e) {
                            e.preventDefault();
                            if( $this.closest('overlay').hasClass('overlay-quickview') ){
                                addOverlay(volContent, 'fine-print', false);
                            }
                        })
                    }
                    if ( $this.data('fine-print-link') != '') {
                        let isLastChance = ( $this.data('last-chance') == undefined || !$this.data('last-chance') ) ? "" : 'last-chance';
                        if( isLastChance != '' ){
                            $("#mobile_summary .fine-print").addClass(isLastChance);
                        }
                        let $vbtn = $('<button type="button" class="fint-print ' + isLastChance + '">' + $this.data('fine-print-link') + '</button>');
                        $_product.find('.fine-print-btns').append($vbtn);
                        let volContent = '<div class="fine-print__content" role="alertdialog" aria-label="' + $this.data('fine-print-link') + '" aria-modal="true">' + $this.data('fine-print-text') + '</div>';
                        $_product.find('.fine-print-btns button').on('click', function (e) {
                            e.preventDefault();
                            addOverlay(volContent, 'fine-print', false);
                        })
                    }
                }
            }

            if (!$this.parents('.overlay-quickview').length) {
                let data = { 'fashionchange': true, 'id': $this.data('id') };


                let params = new URLSearchParams(window.location.search)
                for (const param of params) {
                    if (param[0] === 'product' || param[0].indexOf('pa_') !== -1) {
                        params.delete(param[0])
                    }
                }
                let url = windowUrl + $this.data('style') + '/';
                if (params.size > 0) {
                    url += '?' + params.toString()
                }


                if (pushState && url.indexOf('undefined') === -1 && $('div.type-product').attr('class').split(/\s+/).filter(function (w) {
                    return w.indexOf('product-type') !== -1
                })[0] !== 'product-type-bundle') {


                    history.replaceState(data, '', url);

                } else {
                    selectVariation($this, $this.data('country'), $this.data('style'))
                }
            } else {

                selectVariation($this, $this.data('country'), $this.data('style'))
            }


            if (ubProductData?.fashion_matching == '1') updateBuyBoxProductVariation.call($this, style);


        }


    }

    function ub_update_bb_product($this, pushMobile = true) {
        let $bb_product = $this.closest('.bb-product-variable');

        if ($this != null) {

            let country = $this.data('country');
            let style = $this.data('style');

            if (pushMobile && !$this.parents('.overlay-quickview,.products,.wc-block-grid__products ').length) {

                setTimeout(function () {
                    let mobileSwatch = $('.atc-mob-swatch-list .mobile-bb-swatch-option[data-style="' + style + '"]').first();
                    if (mobileSwatch && mobileSwatch.length) {

                        updateMobileSwatch(mobileSwatch, true)
                    }

                }, 300)

            }

            $bb_product.find('.bb-swatch-option').removeClass('current');
            $this.addClass('current').attr("aria-pressed", true);
            // id="buy_box_product"

        }


    }

    $(document).on('click', '.buy-box-wrapper .bb-swatch-option', function () {
        ub_update_bb_product($(this));
    });


    if ($('.product-type-simple').length) { //Workaround to add fine print for simple products.  TODO: pull into PHP and/or refactor for DRY
        var $product = $('.product');
        if ($product.data('fine-print-link') != '') {
            $('p.price').append($('<div class="fine-print-btns">'));
            if ($product.data('fine-print-link') && $product.data('fine-print-link') != '') {
                let isLastChance = ( $product.data('last-chance') == undefined || $product.data('last-chance') == "" ) ? "" : 'last-chance';
                let $pbtn = $('<button type="button" class="fint-print '+ isLastChance +' ">' + $product.data('fine-print-link') + '</button>');
                $('.fine-print-btns').append($pbtn);
                let polContent = '<div class="fine-print__content" role="alertdialog" aria-label="' + $product.data('fine-print-link') + '" aria-modal="true">' + $product.data('fine-print-text') + '</div>';
                $('.fine-print-btns button').on('click', function (e) {
                    e.preventDefault();
                    addOverlay(polContent, 'fine-print');
                })
            }
        }
    }
    window.addEventListener('popstate', function (e) {

        if (e.state == null || !e.state.fashionchange) return;
        ub_update_product($('.swatch-option[data-id=' + e.state.id + ']'), false);
    });
    $(document).on('found_variation', '.variations_form', function (event, variation) {
        updateOgMetaAndStructuredData(variation);
    });

    function updateOgMetaAndStructuredData(variation) {
        // Update Open Graph meta tags
        if (typeof variation === 'undefined') return;
        let ogTitle = document.querySelector('meta[property="og:title"]');
        let ogDesc = document.querySelector('meta[property="og:description"]');
        let ogImage = document.querySelector('meta[property="og:image"]');
        if (variation.hasOwnProperty('display_name') && ogTitle !== null) ogTitle.setAttribute('content', variation.display_name);
        if (variation.hasOwnProperty('ub_description') && ogDesc !== null) ogDesc.setAttribute('content', variation.ub_description);
        if (variation.hasOwnProperty('image') && ogImage !== null) ogImage.setAttribute('content', variation.image.full_src);

        // Find the correct WooCommerce structured data script tag
        const structuredDataScripts = Array.from(document.querySelectorAll('script[type="application/ld+json"]'));
        const targetScript = structuredDataScripts.find((script) => {
            const data = JSON.parse(script.innerText);
            return data["@graph"] && data["@graph"].some((item) => item["@type"] === "Product");
        });

        if (targetScript) {
            // Update WooCommerce structured data
            const structuredData = JSON.parse(targetScript.innerText);
            const productInfoIndex = structuredData["@graph"].findIndex((data) => data["@type"] === "Product");

            if (productInfoIndex !== -1) {
                const productInfo = structuredData["@graph"][productInfoIndex];
                productInfo.name = variation.display_name;
                productInfo.description = variation.ub_description;
                productInfo.image = [variation.image.full_src];
                productInfo.sku = variation.sku;
                productInfo.price = variation.display_price;

                if (variation.display_price) {
                    const offersIndex = productInfo.offers.findIndex((offer) => offer["@type"] === "AggregateOffer");
                    if (offersIndex !== -1) {
                        productInfo.offers[offersIndex].price = variation.display_price;
                    }
                }

                targetScript.innerText = JSON.stringify(structuredData);
            }
        }
    }

    //upsell swatches
    // $(document).on('click', '.up-sells .swatch-option, .cross-sells .swatch-option, .mini-cart .swatch-option', function(){
    //     const $this = $(this);
    //     const label = $(this).data('label');
    //     // const id = $(this).data('id');
    //     const img = $(this).data('thumb');
    //     const desc = $this.data('desc');
    //     let $_product=$(this).closest('.mini_cart_item');
    //     $_product.find('.product-color').text(label)
    //     $_product.find('img:eq(0)').replaceWith(img)
    //     $_product.find('.product-description').html(desc)
    //     $(this).parent().find('.swatch-option').removeClass('current');
    //
    //
    //     $(this).addClass('current')
    // })
    function updateMobileSwatch($this, isBBProduct = false) {
        const swatchStyle = $this.find('.swatch-image').attr('style')

        let parentClass = isBBProduct ? '.bb-product-variable' : '.product';
        let swatchClass = isBBProduct ? '.bb-swatch-option' : '.swatch-option';

        $(`.mobile-swatch-option.current, .mobile-swatch-option ${swatchClass}`).removeClass('current')
        $this.addClass('current');

            const swatchLabel = $(' .mobile-swatch-option.current .swatch-label').text()
            const swatchPrice = $('.mobile-swatch-option.current .swatch-price').html()
            const $selected = $(`${parentClass} .mob-swatch-selected`);

            $selected.find('.swatch-image').attr('style', swatchStyle)
            $selected.find('.swatch-fashion').attr('aria-label', swatchLabel)
            $selected.find('.swatch-label').text(swatchLabel)
            $selected.find('.swatch-price').html(swatchPrice)


    }

    // fixed product sticky dropdown is not functioning on mobile
    $(document).off('click', '.mobile-swatch-list-toggle, .mob-swatch-selected');
    $(document).on('click', '.mobile-swatch-list-toggle, .mob-swatch-selected', function () {
        $('.atc-mob-contain').toggleClass('open')
        
        if( $('.atc-mob-contain').hasClass('open')){
            $('.mob-swatch-selected').attr('aria-expanded', 'true');
        }else{
            $('.mob-swatch-selected').attr('aria-expanded', 'false');
        }
    });
    $(document).on('click', '.mobile-swatch-option', function () {
        //toggle selected

        updateMobileSwatch($(this))
        let style = $(this).data('style')
        $('.variations__swatches:eq(0) .swatch-option[data-style="' + style + '"]').trigger('click')

        $(this).parents('.atc-mob-contain').removeClass('open')
        if( $('.atc-mob-contain').hasClass('open')){
            $('.mob-swatch-selected').attr('aria-expanded', 'true');
        }else{
            $('.mob-swatch-selected').attr('aria-expanded', 'false');
        }
    });




    //upsell swatches
    $(document).on('click', '.wc-block-grid__product .swatch-option,.up-sells .swatch-option, .cross-sells .swatch-option', function () {
        const $this = $(this);
        const label = $(this).data('add-to-cart-label');
        const id = $(this).data('id');
        const img = $(this).data('thumb');
        const $atc = $(this).parent().parent().find('.add-to-cart');
        let $_product = $(this).closest('.product,.wc-block-grid__product');
        
        // remove existing error messages
        $(this).closest('.product, li').find('.ub-errors').remove();

        $_product.find('.add-to-cart').text(label);


        $_product.find('a.woocommerce-LoopProduct-link:eq(0),.wc-block-grid__product-image').html(img)

        const variableProductPrice = $this.data('price') ?? '';

        $_product.find('.price,.variation__details-price ').html(variableProductPrice);

        $_product.find('.swatch-option').removeClass('current');
        const product_id = $(this).data('parent-id');//get parent id for atc button

        $(this).addClass('current')
        // Do not add the href if the section is from upsells or cross sells
        if (
            ($atc.closest('section').hasClass('up-sells') && $atc.closest('li').hasClass("product-type-variable")) ||
            ($atc.closest('ul').closest('div').hasClass('cross-sells') && $atc.closest('li').hasClass("product-type-variable"))
        ) {
            $atc.removeClass('disabled').removeAttr('aria-disabled').removeAttr('disabled').removeAttr('tabindex');
        } else {
            $atc.removeClass('disabled').removeAttr('aria-disabled').removeAttr('disabled');
        }

        $atc.attr('data-product-id', product_id);
        $atc.attr('data-variation-id', id);
        $_product.find('[name="variation_id"]').val(id);




        if ($_product.find('button.ub-notify').length && !$this.data('coming-soon')) {

            if (!$this.data('stock')) {
                if ($_product.find('button.ub-notify').length) {
                    $_product.find('button.ub-notify').removeClass('hidden').show()
                    if ($_product.find('button.ub-coming-soon').length) {
                        $_product.find('button.ub-coming-soon').addClass('hidden')
                    }
                    $_product.find('.ub-add-to-cart').addClass('hidden')
                } else {


                    $_product.find('.add-to-cart').addClass('disabled').attr('aria-disabled', true).attr('tabindex', "-1" )

                }

            } else {
                if ($_product.find('button.ub-notify').length) {
                    $_product.find('button.ub-notify').addClass('hidden')
                    $_product.find('.ub-add-to-cart').removeClass('hidden')
                }

            }

        } else {
            if (!$this.data('stock')) {
                $atc.addClass('disabled').attr('aria-disabled', 'true').attr('tabindex', "-1" );
            }else{
                $atc.removeAttr('aria-disabled', true).removeAttr('tabindex')
            }
        }
        if ($_product.find('button.ub-coming-soon').length) {
            if ($this.data('coming-soon')) {

                $_product.find('.ub-add-to-cart').hide()
                if ($_product.find('button.ub-notify').length) {
                    $_product.find('button.ub-notify').addClass('hidden')
                }

                $_product.find('button.ub-coming-soon').removeClass('hidden').show()
            } else {

                $_product.find('.ub-add-to-cart').show()
                $_product.find('button.ub-coming-soon').addClass('hidden')

            }
        }

        //Exclsusive swatches
        if ($this.data('is_exclusive_swatch') == 1) {
            if ($_product.find('a.exclusive_swatches_btn').length == 0) {
                $_product.append('<a href="' + $this.data('ex_swatches_url') + '" target="_blank" class="btn btn-primary hidden exclusive_swatches_btn" >' + $this.data('ex_swatches_button_text') + '</a>');
                // reinitializing $product var after appending button
                $_product = $(this).closest('.product,.wc-block-grid__product');
            }
            $_product.addClass('has_exclusive_swatch');
            $_product.find('a.exclusive_swatches_btn').removeClass('hidden').show();
            $_product.find('a.exclusive_swatches_btn').attr('href', $this.data('ex_swatches_url')).html($this.data('ex_swatches_button_text'));

        } else {
            $_product.removeClass('has_exclusive_swatch');
            $_product.find('a.exclusive_swatches_btn').addClass('hidden').hide();
        }

    });
    $(document).on('click', '.up-sells .add-to-cart.disabled', function (e) {
        if (!$('.up-sells .swatch-option.current').length) {
            let $alert = $('<div style="background-color:#f6949b; position:absolute; bottom:2.5rem;" class="ub-messages ub-messages-errors"><p class="error">' + wp.i18n.__('Please select an option first.', 'uppababy') + '</p></div>');
            $(this).parent().append($alert);
            setTimeout(function () {
                $alert.fadeOut(1000, function () {
                    $(this).remove();
                });
            }, 3500);
        }
    });
    if ($('.up-sells .swatch-option.current').length) {
        $('.up-sells .swatch-option.current').click();
    }




    $(document).on('click', '.bundle_form  .swatch-option, .variations_form  .swatch-option', function () {


        //if($(this).hasClass('current')) ub_update_product(null); //NEED TO RESET THE PDP IMAGE FOR THIS ONE
        //else ub_update_product($(this));
        let pushState = !$('body').hasClass('woocommerce-shop');

        ub_update_product($(this), pushState);
        //$('form.variations_form').trigger('reload_product_variations');
    });
    $('.swatch-option').on('mouseleave', function () {
        //$('#pa_styles  option').prop('selected',false);
    });

    $(document).on('click', '.modal .close', function (e) {
        e.stopPropagation();
        e.preventDefault();

        $('.modal').removeClass('notify').removeClass('coming-soon').addClass('hidden');
    });

    function openWaitlistForm(type, $this) {
        let $_product = $this.closest('.product,.wc-block-grid__product');
        let productId = $_product.find('[name="product_id"]').val()

        if(!productId){
            productId = $_product.find('.gtm4wp_productdata').data('gtm4wp_product_data').internal_id
        }

        let variationId = $_product.find('.swatch-option.focus-ring.current').data('id');

        $('.waitlist-message>span').text('').removeClass('error')
        if (type === 'coming-soon') {

            const details = $this.data('waitlist_details')
            if (details.waitlist_heading) {
                $('#waitlistModal').find('.waitlist-content h2').text(details.waitlist_heading)
            }

            if (details.waitlist_copy) {
                $('#waitlistModal').find('.waitlist-content p').replaceWith(details.waitlist_copy)

            }
        }


        $('#waitlist_variation_id').val(variationId)

        $('#waitlist_product_id').val(productId)
        $('#waitlistModal').removeClass('coming-soon')
        $('#waitlistModal').removeClass('notify')

        $('#waitlistModal').addClass(type).removeClass('hidden');
    }

    $(document).on('click', '.coming-soon-ajax, .notify-ajax, .ub-notify', function (e) {
        e.stopPropagation();
        e.preventDefault();
        let type = '';
        if ($(this).hasClass('coming-soon-ajax')) {
            type = 'coming-soon'
        } else {
            type = 'notify'
        }


        openWaitlistForm(type, $(this))

    })

    $(document).on('submit', '#waitlistForm', function (e) {
        e.stopPropagation();
        e.preventDefault()
        if (!document.getElementById('waitlist_email').checkValidity()) {
            return;
        }

        const data = Object.values(this).reduce((obj, field) => {
            obj[field.name] = field.value;
            return obj
        }, {})

        $(this).find('button.waitlist-submit').attr('aria-disabled', true)
        $(this).find('.waitlist-message>span').removeClass('error').text('Submitting...')

        $.post('/wp-json/uppababy/v1/waitlist/', data).then((r) => {
            $(this).find('button.waitlist-submit').attr('aria-disabled', false)

            if (r.success) {
                $(this).find('.waitlist-message>span').text(r.message);
                setTimeout(function () {
                    $('.modal').addClass('hidden')
                }, 3000)
            } else {
                $(this).find('.waitlist-message>span').addClass('error').text(r.message)
            }
        })
    });


    $(document).on('click', '.add-to-cart-ajax, .bundle_add_to_cart_button', function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(this).hasClass('coming-soon-ajax')) {
            openWaitlistForm('coming-soon', $(this))
            return;
        }

        var $button = $(this);
        var $li = $(this).closest('li'),
        isProductBlock = $li.hasClass('wc-block-grid__product'),
        $target = $li.find('.variation__details, .wc-block-grid__product-price'),
        $current = $li.find('.swatch-option.focus-ring.current');

        // remove if any errors are there 
        $(this).prev('.ub-errors').remove();


        if ( $button.prop('disabled') || $button.prop('aria-disabled') || $button.hasClass('disabled')) {
           var styleSelectMessage = wp.i18n.__('Please select a style to continue.');

            if ( !$current.length ) {
                if (!$li.find('.ub-errors p:contains("' + styleSelectMessage + '")').length)
                    (isProductBlock) 
                        ? $target.before('<div class="ub-errors"><p class="ub-errors__error">' + styleSelectMessage + '</p>') 
                        : $target.prepend('<div class="ub-errors"><p class="ub-errors__error">' + styleSelectMessage + '</p>');
            } else {
                if ( $current.data('atc-error-message') !== ''  && !$('.ub-errors p:contains("' + $current.data('atc-error-message') + '")').length)
                    (isProductBlock) 
                        ? $target.before('<div class="ub-errors"><p class="ub-errors__error">' + $current.data('atc-error-message') + '</p>') 
                        : $target.prepend('<div class="ub-errors"><p class="ub-errors__error">' + $current.data('atc-error-message') + '</p>');
            }
            $li.find('.variation__details-title p,.variation__details-desc').html('');
            return;
        } else {
            $('.ub-errors').remove();
        }
        var button = this;
        button.disabled = true;

        var args = {};

        // Pass data if product has Secondary product(Buy Box)
        if ($button.hasClass('has_buy_box_product')) {
            args.has_buy_box_product = 1;
            var buy_box_product_id = $('#buy_box_product').is(":checked") ? $("#buy_box_product").val() : false;
            args.buy_box_product_id = buy_box_product_id;
            var bbvariation = $("#buy_box_product").attr("data-bbvariation");

            // send the BB product attributes of the product if available
            if (typeof bbvariation !== 'undefined' && bbvariation !== false) {
                args.bbvariation = bbvariation;
            }
        }

        // Check if the product is bundled product

        if ($button.hasClass('bundle_add_to_cart_button')) {
            var productID = $button.attr('value');
            var variationSwatch = $button.closest('form').find('.bundled_product .details .variations_form .variations__swatches .variations__group .swatch-option.focus-ring.current');
            if (variationSwatch.length) {
                var variationID = variationSwatch.attr('data-id'),
                    country = variationSwatch.attr('data-country'),
                    style = variationSwatch.attr('data-style');
                args = { 'country': country, 'style': style };
            }
            if ($('form.bundle_form').length) {
                args = {}
                const argArr = $('form.bundle_form').serializeArray()
                for (let i = 0; i < argArr.length; i++) {
                    args[argArr[i].name] = argArr[i].value
                }
            }

            // Check if bundled product has buy box, then pass the data
            if ($button.hasClass('has_buy_box_product')) {
                args.has_buy_box_product = 1;
                var buy_box_product_id = $('#buy_box_product').is(":checked") ? $("#buy_box_product").val() : false;
                args.buy_box_product_id = buy_box_product_id;
                var bbvariation = $("#buy_box_product").attr("data-bbvariation");

                // send the BB product attributes of the product if available
                if (typeof bbvariation !== 'undefined' && bbvariation !== false) {
                    args.bbvariation = bbvariation;
                }
            }


        } else if ($button.hasClass('loop')) {//handling for upsell items
            var productID = $button.attr('data-product-id');
            var variationID = $button.attr('data-variation-id');
        } else {//standard handling
            var $form = $button.closest('form.cart');
            var productID = $form.find('input[name=product_id]').val() || $form.find('input[name=add-to-cart]').val();
            var $variationInput = $form.find('input[name=variation_id]');
            var variationID = $variationInput.length > 0 ? parseInt($variationInput.val()) : 0;
            args['quantity'] = $form.find('input[name=quantity]').val() ?? 1
        }
        addToCartAJAX(productID, variationID, $button, args);
        $button.addClass('processing');
        //
        setTimeout(function () {
            button.disabled = false;
            if (eventResetSelection) {
                window.dispatchEvent(eventResetSelection);
            }
        }, 2000);
    });

    $('.add_to_cart_button.add-to-cart-ajax').dblclick(function (event) {
        event.preventDefault();
        return false;
    });

    $('body').on('click', 'li.mini_cart_item .remove', function (e) {
        e.preventDefault();
        var $button = $(this);
        //$button.parent('li').addClass('pe-none').css('opacity','.5');
        addWaiting();

        $.ajax({
            type: 'POST',
            url: ubWCData.ajaxurl,
            xhrFields: {
                withCredentials: true
            },
            data: {
                nonce: ubWCData.ubnonce,
                action: "ub_ajax_remove_item",
                cart_item_key: $button.data('cart_item_key')
            },
            success: function (response) {
                $(document.body).trigger('wc_fragment_refresh');

                var cartTotal = response.quantity;
                if (cartTotal == 0) {
                    $('.nav-cart').removeClass('has-items');
                    $('.nav-cart__count').html(cartTotal);
                } else {
                    $('.nav-cart').addClass('has-items');
                    $('.nav-cart__count').html(cartTotal)
                }
                removeOverlay();
            },
            complete: function () {
            }
        });
    });
    $('body').on('click', 'li.mini_cart_item .add', function (e) {
        e.preventDefault();
        var $button = $(this);
        //$button.parent('li').addClass('pe-none').css('opacity','.5');
        addWaiting();
        $.ajax({
            type: 'POST',
            url: ubWCData.ajaxurl,
            xhrFields: {
                withCredentials: true
            },
            data: {
                nonce: ubWCData.ubnonce,
                action: "ub_ajax_add_item",
                cart_item_key: $button.data('cart_item_key')
            },
            success: function (response) {
                $(document.body).trigger('wc_fragment_refresh');

                var cartTotal = response.quantity;
                if (cartTotal == 0) {
                    $('.nav-cart').removeClass('has-items');
                    $('.nav-cart__count').html(cartTotal);
                } else {
                    $('.nav-cart').addClass('has-items');
                    $('.nav-cart__count').html(cartTotal)
                }
                removeOverlay();
            },
            complete: function () {
            }
        });
    });

    function update_cart_qty($button){

        addWaiting();

        let action = '';
        if ($button.hasClass('add')) {
            action = 'ub_ajax_add_item'
        } else if ($button.hasClass('remove')) {
            action = 'ub_ajax_remove_item'
        }

        $.ajax({
            type: 'POST',
            url: ubWCData.ajaxurl,
            xhrFields: {
                withCredentials: true
            },
            data: {
                nonce: ubWCData.ubnonce,
                action,
                cart_item_key: $button.data('cart_item_key'),

            },
            success: function (response) {
                $(document.body).trigger('wc_fragment_refresh');
                window.location.reload();

            },
            complete: function () {
            }
        });
    }


    $('body').on('click touchstart', '.the-cart .cart_item.product button', function (event) {
        event.preventDefault();
        update_cart_qty($(this))
		return false;
    });


    $(document).on('click', '.widget_shopping_cart_content .woocommerce-message a', function (event) {
        event.preventDefault();
        var $a = $(event.currentTarget);
        addWaiting();
        $.ajax({
            type: 'GET',
            url: $a.attr('href'),
            dataType: 'html',
            success: function () {
                $(document.body).trigger('wc_fragment_refresh');
                var cartTotal = parseInt($('.wrap-cart-button').html());
                $('.nav-cart__count').html(cartTotal + 1).show();
                removeOverlay();
            },
            complete: function () {
            }
        });
    });

    $('body').on('wc_fragments_refreshed', function () {
        // check if cart is updated and then show cart popup
        if (sessionStorage.getItem('cartUpdated') === 'true') {
            window.dispatchEvent(eventResetSelection);
            var count = parseInt('0' + $(".nav-cart__count").text().trim());
            if ($(".nav-cart__count") && count > 0) {
                ub_toggle_mini_cart(true);
            }
            sessionStorage.setItem('cartUpdated', 'false'); // Reset the flag
        }
        //uppa_show_mini_cart();
    });
    $('body').on('added_to_cart', function () {
        window.dispatchEvent(eventResetSelection);
        var count = parseInt('0' + $(".nav-cart__count").text().trim());
        if ($(".nav-cart__count") && count > 0) {
            ub_toggle_mini_cart(true);
        }
        sessionStorage.setItem('cartUpdated', 'true'); // Set the flag when an item is added to the cart
    });

    //CHECKOUT FORM FUNCTIONS
    $('#ship-to-different-person-checkbox').on('change', function () {
        var $this = $(this);
        if ($this.prop('checked')) {
            ubCheckoutShowField(['shipping_first_name', 'shipping_last_name'], true, true);
            ubClearFields(['shipping_address_1', 'shipping_address_2', 'shipping_city', 'shipping_state', 'shipping_postcode']);
        } else {
            ubCheckoutShowField(['shipping_first_name', 'shipping_last_name'], false, true);
            ubCheckoutUpdateField({
                'shipping_first_name': 'contact_first_name',
                'shipping_last_name': 'contact_last_name'
            });
        }
    });
    $('#bill-to-different-address-checkbox').on('change', function () {
        var $this = $(this);
        if ($this.prop('checked')) {
            ubCheckoutShowField(['billing_first_name', 'billing_last_name', 'billing_address_1', 'billing_address_2', 'billing_city', 'billing_state', 'billing_postcode'], true, true);
        } else {
            //ubCheckoutShowField(['billing_first_name','billing_last_name','billing_address_1','billing_address_2','billing_city','billing_state','billing_postcode'],false,true);
            ubCheckoutUpdateField({
                'billing_first_name': 'shipping_first_name',
                'billing_last_name': 'shipping_last_name',
                'billing_address_1': 'shipping_address_1',
                'billing_address_2': 'shipping_address_2',
                'billing_city': 'shipping_city',
                'billing_state': 'shipping_state',
                'billing_postcode': 'shipping_postcode'
            });
        }
        jQuery('#billing_country, #shipping_country').trigger('change');
        jQuery('#billing_state_field, #shipping_state_field').removeClass('woocommerce-invalid');
    });
    $('#bill-to-shipping-address-checkbox').on('change', function () {
        var $this = $(this);
        if ($this.prop('checked')) {
            //ubCheckoutShowField(['billing_first_name','billing_last_name','billing_address_1','billing_address_2','billing_city','billing_state','billing_postcode'],true,true);
            ubCheckoutUpdateField({
                'billing_first_name': 'shipping_first_name',
                'billing_last_name': 'shipping_last_name',
                'billing_address_1': 'shipping_address_1',
                'billing_address_2': 'shipping_address_2',
                'billing_city': 'shipping_city',
                'billing_state': 'shipping_state',
                'billing_postcode': 'shipping_postcode'
            });
        } else {
            //ubCheckoutShowField(['billing_first_name','billing_last_name','billing_address_1','billing_address_2','billing_city','billing_state','billing_postcode'],false,true);
            ubCheckoutUpdateField({
                'billing_first_name': '',
                'billing_last_name': '',
                'billing_address_1': '',
                'billing_address_2': '',
                'billing_city': '',
                'billing_state': '',
                'billing_postcode': ''
            });
        }
        jQuery('#billing_country, #shipping_country').trigger('change');
        jQuery('#billing_state_field, #shipping_state_field').removeClass('woocommerce-invalid');
    });
    var first_pass = true;
    $('.checkout .next-section').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var step = $this.data('step');

        if (step == 2) {
            //UPDATE CONTACT
            var $info_wrap = $('.info__contact .section__wrap');
            var $info_section = $('.info__contact');
            var $info_review = $info_section.find('.section__review');
            $info_wrap.find('.ub-messages').remove();
            var errors = false;
            let errorct = 0;
            $info_wrap.find('.form-row').each(function () {
                var $field = $(this);
                errors = ubValidateFieldRequired($field);
                if (errors) errorct++;
            });


            if (ubWCData.ubCountry == 'us' && $('input[name="shipping_phone"]').val().match(/^([+][1]|1)?\D?\d{3}\D?\d{3}\D?\d{4}$/) == null) {

                errors = true;
                errorct++;
                $('#shipping_phone_field').removeClass('woocommerce-validated')
                $('#shipping_phone_field .ub-messages').remove();
                $('<div class="ub-messages ub-messages-errors"><p class="error">Must be valid Phone Number</p></div>').insertAfter($('input[name="shipping_phone"]'));
            } else {
                $('#shipping_phone_field .ub-messages').remove();

            }

            $('.wc-avatax-address-validation-result').remove();
            $('.info__shipping .section__wrap .wc_avatax_validate_address.button').click();
            waitForElm('.wc-avatax-address-validation-result').then((el) => {
                if ($(el).hasClass('wc-avatax-address-validation-success')) {
                    //$info_section.addClass('complete');
                } else {
                    errorct++

                }
             if(errorct==0){
                $info_section.addClass('complete');
                $info_wrap.attr('aria-hidden', true);

                $info_review.html(
                    sanitizeHTML($('#contact_email').val())
                );
                proceedNextCheckOutStep();
             }
           
            });    

        } else if (step == 3) {
            $('.wc-avatax-address-validation-result').remove();
            $('.info__billing .section__wrap .wc_avatax_validate_address.button').click();
            waitForElm('.wc-avatax-address-validation-result').then((el) => {
                let errorct = 0;
                if ($(el).hasClass('wc-avatax-address-validation-success')) {
                    //$info_section.addClass('complete');
                } else {
                    errorct++
                }
                if (errorct == 0) {
                    proceedNextCheckOutStep();
                }
            });
        }
        function proceedNextCheckOutStep() {
            var $wrap = $this.closest('.section__wrap');
            var $section = $this.closest('section');
            var $review = $section.find('.section__review');
            $wrap.find('.ub-messages').remove();
            var errors = false;
            let errorct = 0;
            $wrap.find('.form-row').each(function () {
                var $field = $(this);
                errors = ubValidateFieldRequired($field);
                if (errors) errorct++;
            });
            if (errorct > 0) return;
            if (step == 1) {
                $review.html(
                    sanitizeHTML($('#contact_first_name').val()) + ' ' + sanitizeHTML($('#contact_last_name').val()) + '<br/>'
                    + sanitizeHTML($('#contact_email').val()) + '<br/>'
                    + sanitizeHTML($('#shipping_phone').val())
                );

            } else if (step == 2) {
                if ($('#ship-to-different-person-checkbox').prop('checked')) {
                    $('#bill-to-different-address-checkbox').prop('checked', true);
                    ubCheckoutShowField(['billing_first_name', 'billing_last_name', 'billing_address_1', 'billing_address_2', 'billing_city', 'billing_state', 'billing_postcode'], true, true);
                } else {
                    //ubCheckoutUpdateField({'billing_first_name':'shipping_first_name','billing_last_name':'shipping_last_name','billing_address_1':'shipping_address_1','billing_address_2':'shipping_address_2','billing_city':'shipping_city','billing_state':'shipping_state','billing_postcode':'shipping_postcode'});
                }
                $review.html(
                    sanitizeHTML($('#shipping_first_name').val()) + ' ' + sanitizeHTML($('#shipping_last_name').val()) + '<br/>'
                    + sanitizeHTML($('#shipping_address_1').val()) + '<br/>'
                    + sanitizeHTML($('#shipping_address_2').val()) + '<br/>'
                    + sanitizeHTML($('#shipping_city').val()) + ', ' + sanitizeHTML($('#shipping_state').val()) + '<br/>'
                    + sanitizeHTML($('#shipping_postcode').val())
                );
                first_pass = false;


                ubCheckoutUpdateField({ 'billing_phone': 'shipping_phone', 'billing_email': 'contact_email' });
            } else if (step == 3) {
                $review.html(
                    sanitizeHTML($('#billing_first_name').val()) + ' ' + sanitizeHTML($('#billing_last_name').val()) + '<br/>'
                    + sanitizeHTML($('#billing_address_1').val()) + '<br/>'
                    + sanitizeHTML($('#billing_address_2').val()) + '<br/>'
                    + sanitizeHTML($('#billing_city').val()) + ', ' + sanitizeHTML($('#billing_state').val()) + '<br/>'
                    + sanitizeHTML($('#billing_postcode').val())
                );
                updateCardDetails();
            }
            $('section.accordion').removeClass('expanded').attr('aria-expanded', false);
            $wrap.attr('aria-hidden', true);
            $this.closest('section.accordion').addClass('complete').next('section.accordion').addClass('expanded').attr('aria-expanded', true);

        }
    });
    $('#shipping_phone_field').on('input blur', function () {
        if (ubWCData.ubCountry == 'us' && $('input[name="shipping_phone"]').val().match(/^([+][1]|1)?\D?\d{3}\D?\d{3}\D?\d{4}$/) !== null) {
            $('#shipping_phone_field .ub-messages').remove();
        }
    });
    $(document).on('click touchstart keydown', '.checkout .accordion.complete h2', function (event) {

        if (event.type === 'keydown') {
            if (event.key !== 'Enter' && event.key !== ' ') {
                return; // early return for other keydown events
            }
            event.preventDefault();
        }
        $('.accordion').removeClass('expanded').attr('aria-expanded', false);
        var $accordion = $(this).closest('.accordion');
        var $section_wrap = $accordion.find('.section__wrap');
        $accordion.addClass('expanded').attr('aria-expanded', true).removeClass('complete');
        $section_wrap.attr('aria-hidden',false);
    });
    if ($('#place_order').length) {
        var $place_order = $('#place_order');
        $place_order.detach().appendTo($('.info__review-purchase')).addClass('btn primary');

    }

    function sanitizeHTML(text) {
        let div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function updateCardDetails(cardBrand, last4) {
        if (cardBrand && last4) {
            $('.review-order .card-details').remove();
            var cardDetails = $('<div class="card-details"></div>');
            cardDetails.html('Card: ' + cardBrand + ' ending in ' + last4);
            $('.review-order').append(cardDetails);
            $('#card-details').val(cardBrand + '|' + last4);

        } else {
            $('.review-order .card-details').remove();
            $('#card-details').val('');
        }
    }

    function setupStripeCardListener() {
        if (typeof wc_stripe_form !== 'undefined') {
            wc_stripe_form.form.on('change', function () {
                var cardBrand = $('.StripeElement .__PrivateStripeElement span:first-child').text().trim();
                var last4 = $('.StripeElement .__PrivateStripeElement span:nth-child(2)').text().trim();

                if (cardBrand && last4) {
                    updateCardDetails(cardBrand, last4);
                } else {
                    updateCardDetails(null, null);
                }
            });
        } else {
            setTimeout(setupStripeCardListener, 500);
        }
    }

    setupStripeCardListener();


    //WCGS OVERRIDES
    $(document).on('change', '.variations select', function () {
        $('.wcgs-gallery-preloader').addClass('preloading');
        var isPreloaded = setInterval(function () {
            if ($('.wcgs-gallery-preloader').css('opacity') == 0) {
                clearInterval(isPreloaded);
                $('.wcgs-gallery-preloader').removeClass('preloading');
            }
        }, 100);
    });

    //SHOP
    $(document).on('change', '.shop__filters input', function () {
        addWaiting('.shop__products');
        var $input = $(this);
        if ($input.hasClass('family__input')) { //grouped families
            $input.closest('li').find('ul input').prop('checked', $input.prop('checked'));
        }
        if ($(window).innerWidth() < 1024) {
            $_orderby = $('.sort-mobile').val()

        } else {
            $_orderby = $('.sort-desktop').val()
        }
        // $('#orderby').val($_orderby);

        $.ajax({
            type: 'POST',
            url: ubWCData.rest_root + 'shop',
            data: {
                nonce: ubWCData.ubnonce,

                filters: $('.shop__filters form').serialize(),
                orderby: $_orderby,
                ajax_submit: true
            },
            success: function (data) {
                //history.pushState(data,'shop','?'+$('.shop__filters form').serialize());
                $('.shop__products').html(data.html);
                removeOverlay();
            }
        });
    });
    $(document).on('change', '#sort', function () {
        addWaiting('.shop__products');
        var $_orderby = $(this).val();
        $.ajax({
            type: 'POST',
            url: ubWCData.rest_root + 'shop',
            data: {
                nonce: ubWCData.ubnonce,

                filters: $('.shop__filters form').serialize(),
                orderby: $_orderby,
                ajax_submit: true
            },
            success: function (data) {
                //history.pushState(data,'shop','?'+$('.shop__filters form').serialize());
                $('.shop__products').html(data.html);
                removeOverlay();
            }
        });
    });
    // $('.filters__section .toggle').on('click', function () {
    //     $(this).closest('.filters__section').attr('aria-expanded', function (i, attr) {
    //         return attr == 'true' ? 'false' : 'true'
    //     });
    // });
    $(document).on('click', '.filter-crumb', function () {
        var $this = $(this);
        $('#' + $this.data('cat') + '-' + $this.data('val')).prop('checked', false).change();
    });
    $(document).on('click', '.filter-controls>a', function (e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {

            $('aside.shop__filters form').addClass('hidden-mobile')
            //closed
        } else {
            $('aside.shop__filters form').removeClass('hidden-mobile')


        }
        $(this).toggleClass('open')
    });
    if ($('.shop').length) {
        var scrolled = false;
        $(window).on('scroll', function () {
            if ($(window).scrollTop() >= $('.shop').offset().top + $('.shop').outerHeight() - window.innerHeight) {
                if (scrolled) return;
                var $nextpage = $('#nextpage');
                if (!$nextpage.length) return;
                scrolled = true;
                if ($(window).innerWidth() < 1024) {
                    $_orderby = $('.sort-mobile').val()

                } else {
                    $_orderby = $('.sort-desktop').val()
                }
                addWaiting('.shop__products');
                $.ajax({
                    type: 'POST',
                    url: ubWCData.rest_root + 'shop',
                    data: {
                        nonce: ubWCData.ubnonce,
                        action: "ub_shop",
                        filters: $('.shop__filters form').serialize(),
                        paged: $nextpage.val(),
                        orderby: $_orderby,
                        skip_filters: true,
                        ajax_submit: true
                    },
                    success: function (data) {
                        //history.pushState(data,'shop','?'+$('.shop__filters form').serialize());
                        $nextpage.remove();
                        $(document).find('.shop__infinite-scroll').remove();
                        $('.shop__products').html($('.shop__products').html() + data.html);
                        removeOverlay();
                        scrolled = false;
                    }
                });
            }
        });


    }

    /**
     * Show Fineprint on the product quickview 
     * 
     * @param {*} $_product 
     * @param {*} isQuickView 
     */
    function showFinePrint($_product, isQuickView = false){        
        let $product = $_product,
        // Do not remove overlay on quickView for final sale popup 
        shouldRemoveOverlay = isQuickView ? false : true;
        if ($_product ) {
            $_product.find('.fine-print').remove();
            $_product.find('.fine-print-btns').remove();
            var $currentSwatch = $product.find('.variations__swatches .swatch-option.current');
            
            if ( $currentSwatch.data('fine-print-link') != '' ) {
                $_product.find('p.price').append($('<div class="fine-print-btns">'));
                if ( $currentSwatch.data('fine-print-link') && $currentSwatch.data('fine-print-link') != '') {
                    let isLastChance = ( $currentSwatch.data('last-chance') == undefined || $currentSwatch.data('last-chance') == "" ) ? "" : 'last-chance';
                    
                    let $pbtn = $('<button type="button" class="fint-print '+ isLastChance +'">' + $currentSwatch.data('fine-print-link') + '</button>');
                    $_product.find('.fine-print-btns').append($pbtn);
                    let polContent = '<div class="fine-print__content" role="alertdialog" aria-label="' + $currentSwatch.data('fine-print-link') + '" aria-modal="true">' + $currentSwatch.data('fine-print-text') + '</div>';
                    $_product.find('.fine-print-btns button').on('click', function (e) {
                        e.preventDefault();
                        addOverlay(polContent, 'fine-print', shouldRemoveOverlay);
                    })
                }
            }
        }
    }

    $(document).on('click', '.quickview', function (e) {
        let classes = ''
        if ($(this).attr('class').indexOf('vista-config') !== -1) {
            classes = 'vista-config';

        }
        e.preventDefault();
        initProduct();
        let product_id = $(this).data('id');
        const style = $(this).attr('data-style')
        addWaiting();
        $.ajax({
            type: 'POST',
            url: ubWCData.rest_root + 'quick_view',
            data: {
                product_id,
                style,
                classes
            },
            success: function (r) {
                if (r && r.html) {
                    const response = r.html
                    gtag("event", "ub_event_quickview" + classes.replaceAll(' ', '-'), {
                        product_id
                    });

                    addOverlay(response, 'overlay-quickview ' + classes, false);
                    // Initialize the variations form
                    $('.variations_form').each(function () {
                        $(this).wc_variation_form();
                    });
                    $('.woocommerce-product-gallery ').css('opacity', 1);
                    $('.woocommerce-product-gallery__image img').css('opacity', 0);
                    $('.wp-post-image').css('opacity', 1);
                    if ($('.bundle_data').length) {

                        $('.overlay-quickview .bundle_form .bundle_data').each(function () {

                            $(this).wc_pb_bundle_form();

                        });

                    }
                    $('.overlay-quickview').find('.swatch-option.current').trigger('click');
                   
                    // show fineprint button on quickview
                    let $_product = $(".overlay-quickview").find('.product')
                    showFinePrint($_product, isQuickView = true );


                }
            }
        });
    });

    $(document).on("keyup", "#shipping_postcode,#billing_postcode", function () {
        var el = $(this);
        if (el.val().length !== 5) return;
        if (el.val().length === 5 && is_int(el.val())) {
            $.ajax({
                url: "https://api.zippopotam.us/us/" + el.val(),
                cache: true,
                dataType: "json",
                success: function (result, success) {
                    if (el.attr('id') == 'shipping_postcode') {
                        $("input#shipping_city").val(result.places[0]["place name"]); /* Fill the data */
                        $("select#shipping_state").val(result.places[0]["state abbreviation"]).change();

                        var shippingAddress = {
                            address_1: $('#shipping_address_1').val(),
                            address_2: $('#shipping_address_2').val(),
                            city: $('#shipping_city').val(),
                            state: $('#shipping_state').val(),
                            postcode: $('#shipping_postcode').val(),
                            country: $('#shipping_country').val()
                        };
                        // Update the checkout preview
                        $.ajax({
                            url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'update_order_review'),
                            type: 'POST',
                            data: {
                                shipping_address: shippingAddress
                            },
                            success: function (response) {
                                // Update the checkout preview with the latest data
                                $('body').trigger('update_checkout');
                            }
                        });
                    } else {
                        $("input#billing_city").val(result.places[0]["place name"]); /* Fill the data */
                        $("select#billing_state").val(result.places[0]["state abbreviation"]).change().trigger('change');
                    }
                    $('body').trigger('update_checkout');
                },
                error: function (result, success) {
                    console.log(result);
                },
            });
        }
    });

    // Reset max value for quantity input box to hide real stock
    var qty = $('form.woocommerce-cart-form').find('input.qty');
    qty.attr('max', '');

    //fixed ATC
    $(window).scroll(function () {
        fix_atc();
    });

    function fix_atc() {
        const $atc = $('.atc-mob-contain'),
            scroll = $(window).scrollTop(),
            windowHeight = $(window).height();
        if (!$atc.length) {
            return;
        } else {
            const atcOffset = $atc.offset().top,
                atcHeight = $atc.outerHeight();

            if ((scroll < atcOffset + atcHeight) && (scroll + windowHeight > atcOffset)) {
                $atc.removeClass('fixed-atc');
            } else {
                $atc.addClass('fixed-atc');
            }
        }
    }

    // Check if the product and buy box product has same variations
    $(document).on('click', '.product_has_buy_box .bb-swatch-option.focus-ring', function (e) {
        const style = $(this).data('style');
        updateBuyBoxProductVariation.call($(this), style);
    });

    // Update the title on variation click
    $(document).on('click', '.single-product .variations__group:eq(0) .swatch-option, .single-product .variations__group+.variations__group .swatch-option', function(e) {
        var title = window.top.document.title,
        label = $(this).data('label');
        var titleArray = title.split(' - ');
        if( titleArray.length == 3 ){
            titleArray[1] = label;
        }else{
            siteTitle = titleArray[1];
            titleArray[1] = label;
            titleArray[2] = siteTitle;
        }
        window.top.document.title = titleArray.join(' - ');
    })

    // Select the first variation on variable products on cross sales.
    $(".cross-sells li.product-type-variable .swatch-option").removeClass('current').first().addClass('current').trigger('click');
    
});



function addToCartAJAX(productID, variationID, $button, args = null) {
         // Add disabled attributes and class while adding to cart
    $button.attr('aria-disabled', true).addClass('disabled');
    const update_product = $button.data('update-product');

    setTimeout(function () {
        ub_add_to_cart_gtm($button[0], args)
    }, 100)

    jQuery.ajax({
        url: ubWCData.ajaxurl,
        type: 'POST',
        xhrFields: {
            withCredentials: true
        },
        data: {
            nonce: ubWCData.ubnonce,
            action: 'ub_ajax_add_to_cart',
            variation_id: variationID,
            product_id: productID,
            quantity: args['quantity'] ?? 1,
            args: args,
            update_product
        },
        success: function (response) {
            $cartIcon = jQuery('.nav-cart__count');
            $cartIcon.html(response.quantity);
            if (!isNaN(response.quantity) && response.quantity > 0) jQuery('.nav-cart').addClass('has-items');
            else if (!isNaN(response.quantity) && response.quantity == 0) jQuery('.nav-cart').removeClass('has-items');



            if (response.redirect) {
                window.location = response.redirect
            } else {
                jQuery(document.body).trigger('wc_fragment_refresh');

                if (window.innerWidth > 768 && !$cartIcon.is(':visible')) {
                    $cartIcon.show(function () {
                    });
                }
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            }
            // remove the disabled attr and class
            $button.removeAttr('aria-disabled').removeAttr('disabled').removeClass('disabled');
        }
    });

}
function ub_selected_variation(product_form) {
    let product_data_el = product_form.querySelector('[name=gtm4wp_product_data]');
    let productdata;
    let current_product_detail_data;
    try {
        if (product_data_el) {

            current_product_detail_data = JSON.parse(product_data_el.value);
        } else {
            product_data_el = product_form.querySelector('.gtm4wp_productdata');
            current_product_detail_data = JSON.parse(product_data_el.getAttribute('data-gtm4wp_product_data'));
        }

    } catch (e) {
        console && console.error && console.error(e.message);

        return false;
    }

    current_product_detail_data.price = gtm4wp_make_sure_is_float(current_product_detail_data.price);

    const variations = jQuery(product_form).data('product_variations');
    if (variations && variations.length) {
        const style = jQuery(product_form).find('.swatch-option.current').data('style');
        const country = jQuery(product_form).find('.swatch-option.current').data('country');
        let variation = variations.filter((v) => v.attributes.attribute_pa_styles === style && v.attributes.attribute_pa_countries === country)

        if (variations && variation.length) {

            const product_variation = variations[0];
            current_product_detail_data.id = product_variation.variation_id;
            current_product_detail_data.item_id = product_variation.variation_id;
            current_product_detail_data.sku = product_variation.sku;
            if (gtm4wp_use_sku_instead && product_variation.sku && ('' !== product_variation.sku)) {
                current_product_detail_data.id = product_variation.sku;
                current_product_detail_data.item_id = product_variation.sku;
            }
            current_product_detail_data.price = gtm4wp_make_sure_is_float(product_variation.display_price);

            let product_variation_attribute_values = [];
            for (let attrib_key in product_variation.attributes) {
                product_variation_attribute_values.push(product_variation.attributes[attrib_key]);
            }
            current_product_detail_data.variant = product_variation_attribute_values.join(',');
        }


    }



    return current_product_detail_data;
}

function ub_selected_second_product(product_form, product_id, variation_id) {
    const product_data_el = product_form.querySelector('[name=gtm4wp_product_data_' + product_id + ']');

    if (!product_data_el) {

        return false;
    }
    let current_product_detail_data;
    try {
        current_product_detail_data = JSON.parse(product_data_el.value);
    } catch (e) {
        console && console.error && console.error(e.message);

        return false;
    }

    current_product_detail_data.price = gtm4wp_make_sure_is_float(current_product_detail_data.price);
    if (variation_id > 0) {
        const variations = jQuery(product_form).data('variations');
        const variations_2 = jQuery(product_form).data('variations_2');
        let variation, current_variation = false;
        let product_variation = false;
        if (variations_2 && variation_2.length) {
            variation = variations_2.filter((v) => v.product_id === variation_id)
            if (!variation.length) {
                product_variation = variation[0]
            }

        }
        if (!variation && variations && variations.length) {

            variation = variations.filter((v) => v.product_id === variation_id)
            if (!variation.length) {
                product_variation = variation[0]
            }
        }

        if (current_variation) {

            current_product_detail_data.id = product_variation.variation_id;
            current_product_detail_data.item_id = product_variation.variation_id;
            current_product_detail_data.sku = product_variation.sku;
            if (gtm4wp_use_sku_instead && product_variation.sku && ('' !== product_variation.sku)) {
                current_product_detail_data.id = product_variation.sku;
                current_product_detail_data.item_id = product_variation.sku;
            }
            current_product_detail_data.price = gtm4wp_make_sure_is_float(product_variation.display_price);

            let product_variation_attribute_values = [];
            for (let attrib_key in product_variation.attributes) {
                product_variation_attribute_values.push(product_variation.attributes[attrib_key]);
            }
            current_product_detail_data.variant = product_variation_attribute_values.join(',');
        }



    }




    return current_product_detail_data;
}

function ub_add_to_cart_gtm(event_target_element, args) {

    let product_form = event_target_element.closest('form.cart, li.product,li.wc-block-grid__product');

    if (!product_form) {
        product_form = event_target_element;
    }

    let product_variant_id = jQuery(product_form).find('[name="variation_id"]');

    if (product_variant_id && product_variant_id.length > 0 && product_variant_id[0].value) {
        const selected_product_variation = ub_selected_variation(product_form);

        if (selected_product_variation) {

            const qty_el = product_form.querySelector('[name=quantity]');
            selected_product_variation.quantity = (qty_el && qty_el.value) || 1;

            let atc_products = [selected_product_variation];
            let atc_value = (selected_product_variation.price * selected_product_variation.quantity).toFixed(2)

            if (args.buy_box_product_id) {
                const secondary_product = ub_selected_second_product(product_form, args.buy_box_product_id, args.bbvariation);
                if (secondary_product) {
                    atc_products.push(secondary_product);
                    atc_value = (parseFloat(atc_value) + parseFloat(secondary_product.price)).toFixed(2)
                }
            }


            gtm4wp_push_ecommerce('add_to_cart', atc_products, {
                'currency': gtm4wp_currency,
                'value': atc_value
            });
        }
    }
    else {

        let product_data_el = product_form.querySelector('[name=gtm4wp_product_data]');
        let productdata;
        if (product_data_el) {
            productdata = gtm4wp_read_from_json(product_data_el.value);

        } else {
            product_data_el = product_form.querySelector('.gtm4wp_productdata');
            productdata = gtm4wp_read_from_json(product_data_el.getAttribute('data-gtm4wp_product_data'));
        }



        productdata.quantity = product_form.querySelector('[name=quantity]') && product_form.querySelector('[name=quantity]').value;
        if (isNaN(productdata.quantity)) {
            productdata.quantity = 1;
        }


        let atc_products = [productdata];
        let atc_value = (productdata.price * productdata.quantity).toFixed(2)

        if (args.buy_box_product_id) {
            const secondary_product = ub_selected_second_product(product_form, args.buy_box_product_id, args.bbvariation);
            if (secondary_product) {
                atc_products.push(secondary_product);
                atc_value = (parseFloat(atc_value) + parseFloat(secondary_product.price)).toFixed(2)
            }
        }

        gtm4wp_push_ecommerce('add_to_cart', atc_products, {
            'currency': gtm4wp_currency,
            'value': atc_value
        });
    }
}

function ub_cart_close() {
    jQuery("#ub-cart").fadeOut();
}

function ub_toggle_mini_cart(force_show = false) {
    var $cart = jQuery("#ub-cart");
    if ($cart.is(':visible') && !force_show) {
        $cart.fadeOut(function () {
            jQuery(this).attr('aria-expanded', 'false');
        });
    } else {
        $cart.fadeIn(function () {
            jQuery(this).attr('aria-expanded', 'true');
        });
        
        // Select the first variation on variable products on cross sales.    
        jQuery(".cross-sells li.product-type-variable .swatch-option").removeClass('current').first().addClass('current').trigger('click');        
        
    }
}

jQuery(document).on('wc_fragment_refresh', function() {
    // Select the first variation on variable products on cross sales.    
    setTimeout(() => {
        jQuery(".cross-sells li.product-type-variable .swatch-option").removeClass('current').first().addClass('current').trigger('click'); 
    }, 1500);
});


function ubCheckoutShowField(fields, show = true, clear = false) {
    for (var k in fields) {
        if (show) {
            jQuery('#' + fields[k] + '_field').removeClass('hidden');
            jQuery('#' + fields[k]).attr('type', 'text').removeClass('input-hidden').addClass('input-text');
            if (clear) jQuery('#' + fields[k]).val('');
        } else {
            jQuery('#' + fields[k] + '_field').addClass('hidden');
            //jQuery('#'+fields[k]).attr('type','hidden').removeClass('input-text').addClass('input-hidden');
            if (clear) jQuery('#' + fields[k]).val('');
        }
    }
}

function ubCheckoutUpdateField(fields) {
    for (var k in fields) {
        var $updateField = jQuery('#' + k);
        //if($updateField.attr('type')=='hidden')
        if (fields[k] == '') {
            $updateField.val('').trigger('change');
        } else {
            $updateField.val(jQuery('#' + fields[k]).val()).trigger('change');
        }
    }
    jQuery(document.body).trigger('update_checkout');
}

function ubClearFields(fields) {
    for (var k in fields) {
        var $updateField = jQuery('#' + fields[k]);
        $updateField.val('');
    }
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

